import React from "react";
import ProductLine from "./ProductLine";
import Translate from "localization/Translate";

export default function ({listItems, setListItems, readonly}) {
    return (
        <table className={"responsiveTable bold borderBottomTd documentTable"}>
            <thead style={{
                fontSize: '1.43rem',
                borderBottom: "0.142857rem solid rgb(235, 235, 235)"
            }}>
            <tr>
                <th><input type={"checkbox"} disabled={readonly} onChange={ (e) => {
                    setListItems(listItems.map(item => {
                        item.checked = e.target.checked;
                        return {
                            checked: e.target.checked,
                            product: item.product
                        };
                    }), e.target.checked, () => {
                        console.log("setListItems do uncheck");
                        e.target.checked = false;
                        setListItems(listItems.map(item => {
                            item.checked = e.target.checked;
                            return {
                                checked: e.target.checked,
                                product: item.product
                            };
                        }));
                    });
                }}/></th>
                <th><Translate id={"Product"}/></th>
                <th><Translate id={"Item code"}/></th>
                <th><Translate id={"Quantity"}/></th>
                <th><Translate id={"Return quantity"}/></th>
                <th><Translate id={"Total"}/></th>
            </tr>
            </thead>
            <tbody>
            {
                listItems.map((item, index) => {
                    return <ProductLine
                        key={index}
                        item={item}
                        onCheckToggle={(checked, e) => {
                            if(readonly) {
                                return;
                            }
                            setListItems(listItems.map((listItem, listItemIndex) => {
                                if(listItemIndex === index){
                                    return {
                                        checked: checked,
                                        product: listItem.product
                                    };
                                }
                                return listItem;
                            }), e.target.checked, () => {
                                e.target.checked = false;
                            });
                        }}
                        onChangeReturnAmount={(returnAmount) => {
                            setListItems(listItems.map((listItem, listItemIndex) => {
                                if(listItemIndex === index){
                                    listItem.product.returnAmount = returnAmount;
                                }
                                return listItem;
                            }), false, () => {});
                        }}
                    />
                })
            }
            </tbody>
        </table>
    );
}
